<template>
  <div class="invite-member-already-exists-error-page">
    <div class="emoji">😔</div>
    <div class="title">לא הצלחנו לצרף אותך לתזרים של {{ inviter }}</div>
    <div class="explain">מספר הטלפון שלך כבר קיים אצלנו במערכת. כרגע אפשר להתחבר רק לתזרים אחד.</div>
    <support-footer />
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';

export default {
  name: 'InviteMemberAlreadyExistsError',
  components: {
    SupportFooter: BaseUI.SupportFooter,
  },
  async created() {
    Segment.trackUserGot('InviteMemberAlreadyExistsError', { phoneNumber: this.phoneNumber });
  },
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
    inviter: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import 'src/scss/mixins';

  .invite-member-already-exists-error-page {
    @include responsive-padding;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .emoji {
      margin-top: 50px;
      font-size: 76px;
    }

    .title {
      @include white-page-frame-title;
      margin-top: 30px;
      margin-bottom: 20px;
      line-height: 30px;
    }

    .explain {
      max-width: 300px;
      font-size: 16px;
      line-height: 24px;
      white-space: pre-wrap;

      .explain-bold {
        font-weight: bold;
      }
    }

    .support-footer {
      margin-top: 30px;
    }
  }

</style>
